import { ESellersInfoModalActionTypes } from '../../actions/sellersInfoModal';
import { IAppState, ISellersInfoModalState, TActions } from '../../common/state';

export const defaultState: ISellersInfoModalState = {
  isOpen: false,
};

export function sellersInfoModalReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case ESellersInfoModalActionTypes.Open: {
      return {
        ...state,
        sellersInfoModal: {
          isOpen: true,
        },
      };
    }
    case ESellersInfoModalActionTypes.Close: {
      return {
        ...state,
        sellersInfoModal: defaultState,
      };
    }
  }

  return state;
}
